import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=1d4e4f5b&scoped=true&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"
import style0 from "./Incident.vue?vue&type=style&index=0&id=1d4e4f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e4f5b",
  null
  
)

export default component.exports